import { computed, inject, markRaw, ref } from 'vue'

import { SET_CURRENT_REPOSITORY } from '@/const'

import { useModalsStore } from '@/store/modals'
import { useRepositoriesStore } from '@/store/repositories'

import Repositories from '@/modules/modals/Repositories/List/Repositories.vue'
import RepositoryCreate from '@/modules/modals/Repositories/Data/RepositoryCreate.vue'

export const useRepositories = () => {

  const modalsStore = useModalsStore()
  const repositoriesStore = useRepositoriesStore()
  
  const setCurrentRepository = inject<(id?: string) => void>(SET_CURRENT_REPOSITORY)
  
  const query = ref('')
  
  const name = computed(() => repositoriesStore.getCurrentName)
  const owner = computed(() => repositoriesStore.isOwner ? undefined : repositoriesStore.getCurrentOwner)
  
  const repositories = computed(() =>
    repositoriesStore.getList.map(item => ({
      id: item.id,
      name: item.name,
      active: item.id === repositoriesStore.getCurrentId,
    })),
  )
  
  const filteredRepositories = computed(() => {
    const search = query.value.trim().toLowerCase()
    if (!search) return repositories.value
    return repositories.value.filter(repository => repository.name.toLowerCase().includes(search))
  })
  
  const handleSelect = (id: string) => {
    if (id === repositoriesStore.getCurrentId) return
    setCurrentRepository?.(id)
  }
  
  const handleCreate = () => {
    const modalInstance = modalsStore.init('create-repository', markRaw(RepositoryCreate))
    modalInstance?.open(modalsStore.getZIndex(), {})
  }
  
  const handleManage = () => {
    const modalInstance = modalsStore.init('repositories', markRaw(Repositories))
    modalInstance?.open(modalsStore.getZIndex(), {})
  }

  return {
    query,
    name,
    owner,
    repositories: filteredRepositories,
    handleSelect,
    handleCreate,
    handleManage,
  }
}
